<ion-content class="login --no-bg">
  <div class="login__background"></div>
  <div class="login__content">
    <span class="login__content__title --welcome" [innerHTML]="'Welcome 👋️ <br> Sabine'"></span>
    <span class="login__content__text" [innerHTML]="'Turn on notifications 🔔 to succeed in your business progress.'"></span>
    <div class="login__content__form">
      <div class="login__content__form__buttons --forget-password">
        <ion-button class="button login__content__form__buttons__button" [innerHTML]="'Yes, allow notifications'"></ion-button>
        <ion-button
          class="button --text --dark login__content__form__buttons__button"
          [innerHTML]="'No, I’ll do this by my own'"
        ></ion-button>
      </div>
    </div>
  </div>
</ion-content>
